// extracted by mini-css-extract-plugin
export var divider = "experience-module--divider--7IziC";
export var row = "experience-module--row--EQF9m";
export var title = "experience-module--title--fRKw6";
export var desc = "experience-module--desc--fMuvM";